import { useStopwatch } from './Stopwatch.hooks';
import { Digit, Wrapper } from './Stopwatch.style';

export type StopwatchProps = {
  ts: number;
};

export function Stopwatch(props: StopwatchProps) {
  const { ts } = props;
  const digits = useStopwatch(ts);

  if (!ts) {
    return null;
  }

  function renderDigit(digit: string, index: number) {
    return <Digit key={index}>{digit}</Digit>;
  }

  function renderDigits() {
    return digits.map((digit, index) => renderDigit(digit, index));
  }

  return (
    <Wrapper className='Stopwatch-wrapper' data-testid='Stopwatch-wrapper'>
      {renderDigits()}
    </Wrapper>
  );
}

export default Stopwatch;
